module.exports = require('./umd/embedded.development.js'); // eslint-disable-line global-require